var React = require('react');

function Separator (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M5.96718 4.66918C5.64766 4.34966 5.64766 3.83162 5.96718 3.5121C6.2867 3.19258 6.80474 3.19258 7.12426 3.5121L12.0334 8.42119C12.3529 8.74071 12.3529 9.25876 12.0334 9.57828L7.12426 14.4874C6.80474 14.8069 6.2867 14.8069 5.96718 14.4874C5.64766 14.1678 5.64766 13.6498 5.96718 13.3303L10.2977 8.99973L5.96718 4.66918Z","fill":"#19222A"}));
}

Separator.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none"};

module.exports = Separator;

Separator.default = Separator;
